import * as React from 'react';
import {useRecordContext} from 'react-admin';
import clsx from "clsx";

const ContentCounts = () => {
    const record = useRecordContext<any>();
    if (!record) return null;
    return <div className={'text-xs'}>
        <div className={'whitespace-nowrap'}>
            Lectures: <b>{record.lecturesCount}</b>
        </div>
        <div className={'whitespace-nowrap'}>
            Videos: <b>{record.videosCount}</b>
        </div>
        <div className={'whitespace-nowrap'}>
            Notes: <b>{record.notesCount}</b>
        </div>
        <div className={'whitespace-nowrap'}>
            Homeworks: <b>{record.homeworksCount}</b>
        </div>
        <div className={'whitespace-nowrap'}>
            Exercises: <b>{record.exercisesCount}</b>
        </div>
    </div>;
};
ContentCounts.defaultProps = {
    label: 'Counts'
}
export default ContentCounts;
